// Adapted from dragndrop/src/components/DocumentPreview.tsx
import React from 'react';
import { FileText, Loader2, AlertCircle, CheckCircle } from 'lucide-react';
import { Box, Typography } from '@mui/material';

/**
 * @typedef {import('./types').DocumentMetadata} DocumentMetadata
 */

/**
 * @param {{ document: DocumentMetadata }} props
 * @returns {JSX.Element}
 */
export const DocumentPreview = ({ document }) => {
  const renderStatusIcon = () => {
    switch (document.status) {
      case 'pending':
      case 'processing':
        return <Loader2 className="h-5 w-5 animate-spin text-zinc-500" />;
      case 'completed':
        return <CheckCircle className="h-5 w-5 text-green-500" />;
      case 'failed':
        return <AlertCircle className="h-5 w-5 text-red-500" />;
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        pl: 0,   // Remove left padding
        pr: 1.5, // Keep right padding
        py: 0,   // Remove vertical padding
        border: '1px solid', // border
        borderColor: 'grey.300', // border-zinc-200
        borderRadius: 1, // rounded-md
        mb: 1, // space-y-2 -> applied by parent? check App.tsx later
        bgcolor: 'background.paper', // bg-white
      }}
    >
      <FileText className="h-6 w-6 text-zinc-500 mr-3" />
      <Box sx={{ flexGrow: 1, mr: 2, overflow: 'hidden' }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 'medium',
            color: 'text.primary', // text-zinc-800
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          title={document.name}
        >
          {document.name}
        </Typography>
        {document.status === 'failed' && document.errorMessage && (
          <Typography variant="caption" sx={{ color: 'error.main' }} title={document.errorMessage}>
            {document.errorMessage}
          </Typography>
        )}
      </Box>
      {renderStatusIcon()}
    </Box>
  );
};
